import { render, staticRenderFns } from "./employeesSalaries.vue?vue&type=template&id=e078031c"
import script from "./employeesSalaries.vue?vue&type=script&lang=js"
export * from "./employeesSalaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports